import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';

// Core & Shared
import { CoreModule } from './modules/core/core.module';
import { SharedModule } from './modules/shared/shared.module';

// Pages && Layouts
import { AuthLayoutComponent } from './pages/auth-layout/auth-layout.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { NotFoundPageComponent } from './pages/not-found-page/not-found-page.component';
import { PublicCertificateComponent } from './pages/public-certificate/public-certificate.component';
import { PublicMultiCertificateComponent } from './pages/public-multi-certificate/public-multi-certificate.component';

// Components
import { AppComponent } from './app.component';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { NavMainComponent } from './components/nav-main/nav-main.component';

@NgModule({
  declarations: [
    AppComponent,
    // Pages
    LoginPageComponent,
    NotFoundPageComponent,
    AuthLayoutComponent,
    PublicCertificateComponent,
    PublicMultiCertificateComponent,
    // Components
    LoginFormComponent,
    NavMainComponent
  ],
  imports: [
    CoreModule,
    SharedModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
